import { render, staticRenderFns } from "./Sublist.vue?vue&type=template&id=191ed878"
import script from "./Sublist.vue?vue&type=script&lang=js"
export * from "./Sublist.vue?vue&type=script&lang=js"
import style0 from "./Sublist.vue?vue&type=style&index=0&id=191ed878&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports